import { getSudConfig as getSudConfigRequest } from '@/components/GameRoom/api';

const state = {
  sudConfig: null
};
const mutations = {
  GET_SUD_CONFIG: (state, payload) => {
    state.sudConfig = payload;
  }
};
const actions = {
  getSunConfig({ commit }) {
    return new Promise((resolve, reject) => {
      getSudConfigRequest()
        .then(({ data }) => {
          commit('GET_SUD_CONFIG', data);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
